// This script looks for columns that have data-allow-text-stretch and animates
// any element with the helper class `kingdomi-stretch-text` when it scrolls into view.

(function () {
	if (typeof window === 'undefined') return;

	function initStretchObservers() {
		const columns = document.querySelectorAll('[data-allow-text-stretch]');
		if (!columns.length) return;

		const obs = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					const el = entry.target;
					const elems = el.querySelectorAll('p');
					if (entry.isIntersecting) {
						elems.forEach((e) => e.classList.add('in-view'));
					} else {
						// optional: remove class when out of view
						// elems.forEach(e => e.classList.remove('in-view'));
					}
				});
			},
			{ threshold: 0.15 }
		);

		columns.forEach((col) => obs.observe(col));
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initStretchObservers);
	} else {
		initStretchObservers();
	}
})();
